<template>
	<div id="about">
		<div class="topLan1">
			<img class="CoBrand" @click="jumpToIndex" src="../../static/pic/logo_hudie0@2x.png" />
			<div class="lan">
				<router-link class="box1" :to="{path: 'index'}">首页</router-link>
				<router-link class="box1" :to="{name: 'platform'}">电商平台</router-link>
				<router-link class="box1" :to="{name: 'canvass'}">招商入驻</router-link>
				<router-link class="box1" :to="{name: 'about'}">关于我们
					<div class="boxLine1"></div>
				</router-link>
				<router-link class="box1" :to="{name: 'newsCenter'}">新闻中心</router-link>
				<router-link class="box1" :to="{name: 'recruit'}">人才招聘</router-link>
				<router-link class="box1" :to="{name: 'downLoad'}">下载APP</router-link>
				<!-- <a href="index" class="box1">首页</a>
				<a href="platform" class="box1">电商平台</a>
				<a href="canvass" class="box1">招商入驻</a>
				<a href="about" class="box1">关于我们
					<div class="boxLine1"></div>
				</a>
				<a href="newsCenter" class="box1">新闻中心</a>
				<a href="recruit" class="box1">人才招聘</a>
				<a href="downLoad" class="box1">下载APP</a> -->
			</div>
		</div>

		<div id="id1" style="width: 100%;height: 672px;background: #FFFFFF;margin-top: 122px;">
			<div class="titleLan">
				<div class="title">公司介绍</div>
				<div class="line"></div>
			</div>
			<div class="area1">
				<div class="smallArea1">
					<img class="section1Pic" src="../../static/aboutPic/img_web04_pic1@2x.png" />
					<div class="section1txt">
						蝴蝶供应链有限公司有着十二年的工程机械行业经验和资源沉淀，同时拥有专业的软件开发团队和互联网运营经验，是一家以技术为驱动、数字化解决方案为核心的公司。公司以推动工程机械行业转型为目标，为行业赋能，实现行业的信息化、数字化、智能化，达到降本增效的目的。
					</div>
				</div>
			</div>
		</div>

		<div id="id2" style="width: 100%;height: 1202px;background: #FDFDFD;">
			<div class="titleLan">
				<div class="title">企业文化</div>
				<div class="line"></div>
			</div>
			<div class="area2">
				<div class="smallArea2">
					<div class="smallArea2Lan">
						<img class="section2Pic" src="../../static/aboutPic/icon_web04_culture1@2x.png" />
						<div class="section2txtArea">
							<div
								style="width: 100%;font-size: 36px;font-family: Source Han Sans SC;font-weight: bold;color: #222222;margin-top: 100px;text-align: center;">
								愿景</div>
							<div
								style="width: 360px;font-size: 20px;font-family: Source Han Sans SC;font-weight: 500;color: #222222;margin-top: 20px;text-align: left;text-align: center;">
								成为全球信赖的工程机械行服务商</div>
						</div>
					</div>
					<div class="smallArea2Lan">
						<div class="section2txtArea">
							<div style="width: 100%;text-align: center;font-size: 36px;font-family: Source Han Sans SC;font-weight: bold;color: #222222;margin-top: 87px;">使命</div>
							<div style="width: 315px;font-size: 20px;font-family: Source Han Sans SC;font-weight: 500;color: #222222;margin-top: 20px;text-align: left;text-align: center;">客户第一 合作共赢</div>
						</div>
						<img class="section2Pic" src="../../static/aboutPic/icon_web04_culture2@2x.png" />
					</div>
					<div class="smallArea2Lan">
						<img class="section2Pic" src="../../static/aboutPic/icon_web04_culture3@2x.png"/>
						<div class="section2txtArea">
							<div style="width: 100%;text-align: center;margin-top: 57px;font-size: 36px;font-family: Source Han Sans SC;font-weight: bold;color: #222222;">价值观</div>
							<div style="width: 17.6875rem;display: flex;justify-content: space-between;margin-top: 3.5rem;">
								<div style="width: 5.5rem;display: flex;flex-direction: column;align-items: center;">
									<img style="width: 5.5rem;height: 5.5rem;" src="../../static/aboutPic/icon_p4_jzg1.png"/>
									<div style="width: 100%;text-align: center;font-size: 20px;font-family: Source Han Sans CN;font-weight: 400;color: #477DFD;margin-top: 1.125rem;">客户第一 </div>
								</div>
								<div style="width: 5.5rem;display: flex;flex-direction: column;align-items: center;">
									<img style="width: 5.5rem;height: 5.5rem;" src="../../static/aboutPic/icon_p4_jzg2.png"/>
									<div style="width: 100%;text-align: center;font-size: 20px;font-family: Source Han Sans CN;font-weight: 400;color: #477DFD;margin-top: 1.125rem;">合作共赢 </div>
								</div>
							</div>
							<!-- <div style="width: 100%;display: flex;flex-direction: column;margin-top: 34px;justify-content: center;align-items: center;">
								<div class="section2Box3Lan">
									<img class="section2Box3Pic" src="../../static/aboutPic/icon_web02_star@2x.png" />
									<div class="section2Box3txt">客户第一  奋斗为本  守正出奇</div>
								</div>
								<div class="section2Box3Lan">
									<img class="section2Box3Pic" src="../../static/aboutPic/icon_web02_star@2x.png" />
									<div class="section2Box3txt">认真生活  快乐工作  专注当下</div>
								</div>
								<div class="section2Box3Lan">
									<img class="section2Box3Pic" src="../../static/aboutPic/icon_web02_star@2x.png" />
									<div class="section2Box3txt">自信  自律  自强  自省  自驱</div>
								</div>
								<div class="section2Box3Lan">
									<img class="section2Box3Pic" src="../../static/aboutPic/icon_web02_star@2x.png" />
									<div class="section2Box3txt">拥抱变化 相互信任</div>
								</div>
							</div> -->
							
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div id="id3" style="width: 100%;height: 727px;background-color: #FFFFFF;position: relative;">
			<img  style="position: absolute;width: 100%;height: 727px;" src="../../static/aboutPic/img2.png"/>
			<div class="titleLan" style="position: absolute;">
				<div class="title">发展历程</div>
				<div class="line"></div>
			</div>
			<div style="width: 100%;display: flex;justify-content: center;align-items: center;position: absolute;top: 8.125rem;">
				<img style="width: 53.3125rem;height: 538px;" src="../../static/aboutPic/icon_web04_develop.png"/>
			</div>
		</div>
		
		<div id="id4" style="width: 100%;height: 935px;position: relative;display: flex;justify-content: center;">
			<img style="width: 100%;height: 935px;position: absolute;"  src="../../static/pic/img_web01_bg1.jpg" />
			<div style="width: 1165px;height: 556px;position: relative;margin-top: 190px;">
				<img style="width: 100%;position: absolute;" mode="widthFix" src="../../static/aboutPic/img_web05_partner@2x.png" />
			</div>
			<div class="titleLanSp">
				<div class="titleSp">合作伙伴</div>
				<div class="lineSp"></div>
			</div>
		</div>
		
		<div id="id5" style="width: 100%;height: 662px;background: #FEFEFE;">
			<div class="titleLan">
				<div class="title">相关证书</div>
				<div class="line"></div>
			</div>
			<div class="area1">
				<div class="smallArea5">
					<!-- <el-carousel class="carousel">
					    <el-carousel-item
					        class="carousel flex"
					        v-for="(item, index) in imgs"
					        :key="index"
					    >
							<div style="display: flex;flex-direction: row;justify-content: space-around;">
								<div class="carouselBox1" v-for="(item,index) in setImgs" :key="index">
									<img class="boxImg" :src="item"/>
								</div>
							</div>
					    </el-carousel-item>
					</el-carousel> -->
					<el-carousel class="carousel" :interval="5000" type="card">
					    <el-carousel-item class="carouselItem" v-for="(item,index) in imgs" :key="index">
					      <div class="carouselBox1" >
					      	<img class="boxImg" :src="item"/>
					      </div>
					    </el-carousel-item>
					</el-carousel>
				</div>
			</div>
		</div>
		
		<div id="id6" style="width: 100%;height:900px;background-color: #FFFFFF;">
			<div class="titleLan">
				<div class="title">地理位置</div>
				<div class="line"></div>
			</div>
			<div class="area3">
				<div class="smallArea3">
					<img class="section5MapPic" src="../../static/aboutPic/pic_ditu2@2x.png" />
					<img class="section5MapLocate" src="../../static/aboutPic/icon_dingwei_blue@2x.png" />
					<div class="chongqingtxt">重庆</div>
					<div class="section5Box">
						<div class="section5BoxTitle">重庆</div>
						<div class="section5BoxLine"></div>
						<div class="section5BoxLan">
							<img class="section5BoxLocate" src="../../static/aboutPic/icon_dingwei_small@2x.png" />
							<div class="section5BoxAddress">重庆市渝北区领航路17号</div>
						</div>
					</div>
				</div>
				
			</div>
		</div>
		
		<bottom-area></bottom-area>
		
	</div>
</template>

<script>
	import bottomArea from "../components/bottomArea.vue"
	export default {
		components: {
			bottomArea
		},
		data() {
			return {
				imgs:[
					require("../../static/pic/img_web04_zshu1.jpg"),
					require("../../static/pic/img_web04_zshu2.jpg"),
					require("../../static/pic/img_web04_zshu3.jpg"),
					require("../../static/pic/img_web04_zshu4.jpg"),
					require("../../static/pic/img_web04_zshu5.jpg"),
					require("../../static/pic/img_web04_zshu6.jpg"),
					require("../../static/aboutPic/zs1.png"),
					require("../../static/aboutPic/zs2.png"),
					require("../../static/aboutPic/zs3.png"),
					require("../../static/aboutPic/zs4.png"),
					require("../../static/aboutPic/zs5.png"),
				],
				setImgs:[]
			}
		},
		created() {
			// var list = this.imgs
			// list.splice(4,2)
			// this.setImgs = list
			// console.log(this.setImgs)
			document.documentElement.scrollTop = 0
			
		},
		methods: {
			jumpToIndex(){
				this.$router.push({
					name: 'index',
					params: {}
				});
			}
		}
	}
</script>

<style scoped>
	html,
	body,
	#about {
		width: 100%;
		height: 100%;
		text-align: left;
	}

	a {
		text-decoration: none
	}

	.titleLan {
		width: 100%;
		height: 108px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.titleLanSp{
		position: absolute;
		width: 100%;
		height: 108px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.title {
		margin-top: 53px;
		font-size: 26px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #333333;
	}
	.titleSp{
		margin-top: 53px;
		font-size: 26px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #FFFFFF;
	}
	.line {
		width: 28px;
		height: 2px;
		background: #467CFD;
		margin-top: 16px;
	}
	.lineSp{
		width: 28px;
		height: 2px;
		background: #FFFFFF;
		margin-top: 16px;
	}
	.area1 {
		width: 100%;
		margin-top: 85px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.smallArea1 {
		width: 1215px;
		display: flex;
	}

	.section1Pic {
		width: 560px;
		height: 370px;
	}

	.section1txt {
		width: 608px;
		height: 341px;
		margin-top: 16px;
		margin-left: 45px;
		font-size: 20px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #222222;
		line-height: 40px;
	}

	.area2 {
		width: 100%;
		margin-top: 54px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.smallArea2 {
		width: 1215px;
		display: flex;
		flex-direction: column;
	}

	.smallArea2Lan {
		width: 100%;
		display: flex;
		box-shadow: 0px 0px 12px #F4F6F9;
		margin-bottom:17px ;
	}

	.section2Pic {
		width: 610px;
		height: 316px;
	}

	.section2txtArea {
		width: 610px;
		height: 316px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.section2Box3Lan{
		width: 280px;
		display: flex;
		margin-bottom: 12px;
	}
	.section2Box3Pic{
		margin-top: 6px;
		width: 17px;
		height: 16px;
	}
	.section2Box3txt{
		width: 257px;
		margin-left: 4px;
		font-size: 20px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #222222;
	}
	.smallArea5{
		width: 1474px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.carouselBox1{
		width: 272px;
		height: 380px;
		background: #FFFFFF;
		border-radius: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		box-shadow: 0px 0px 12px #F4F6F9;
	}
	.carouselBox2{
		width: 272px;
		height: 380px;
		background: #FFFFFF;
		border-radius: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		box-shadow: 0px 0px 12px #F4F6F9;
	}
	.carouselBox3{
		width: 272px;
		height: 380px;
		background: #FFFFFF;
		border-radius: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		box-shadow: 0px 0px 12px #F4F6F9;
	}
	.carouselBox4{
		width: 272px;
		height: 380px;
		background: #FFFFFF;
		border-radius: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		box-shadow: 0px 0px 12px #F4F6F9;
	}
	.boxImg{
		width: 240px;
		height: 342px;
	}
	.carousel{
		height: 400px;
		width: 1280px;
	}
	.carouselItem{
		margin-left: 180px;
		height: 400px;
	}
	.el-carousel__container{
		height: 400px;
	}
	.area3{
		margin-top: 40px;
		width: 100%;
		height: 750px;
		position: relative;
		display: flex;
		justify-content: center;
	}
	.section5MapPic{
		position: absolute;
		width: 774px;
		height: 707px;
		left: 0px;
		top: 0px;
	}
	.section5MapLocate{
		position: absolute;
		width: 19px;
		height: 25px;
		left: 284px;
		top: 245px;
	}
	.chongqingtxt{
		position: absolute;
		top: 250px;
		left: 310px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #010101;
	}
	.section5Box{
		position: absolute;
		display: flex;
		flex-direction: column;
		padding: 26px 40px 54px 40px;
		left: 730px;
		top: 230px;
		width: 400px;
		height: 100px;
		background: #F7FBFF;
		border: 1px solid #467CFD;
		border-radius: 4px;
	}
	.section5BoxTitle{
		width: 400px;
		height: 26px;
		font-size: 28px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #293E63;
	}
	.section5BoxLine{
		width: 400px;
		height: 1px;
		background-color: #467CFD;
		margin-top: 27px;
	}
	.section5BoxLan{
		width: 400px;
		display: flex;
		margin-top: 27px;
	}
	.section5BoxLocate{
		width: 14px;
		height: 18px;
	}
	.section5BoxAddress{
		margin-left: 10px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #555F73;
	}
	.smallArea3{
		width: 1212px;
		position: relative;
	}
</style>
